import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import Recommendations from "sections/PersonalAI/Recommendations";
import Quizzes from "sections/PersonalAI/Quizzes";
import { PersonalAITabs } from "constantVariables/tabs";
import { t } from "i18next";
import HeaderSection from "components/HeaderSection";

const tabs = [PersonalAITabs.QUIZZES, PersonalAITabs.RECOMMENDATIONS];

const renderTab = (activeTab) => {
  switch (activeTab) {
    case PersonalAITabs.QUIZZES:
      return <Quizzes />;
    case PersonalAITabs.RECOMMENDATIONS:
      return <Recommendations />;
    default:
      return <Quizzes />;
  }
};

export default function PersonalAI() {
  const { dir, language } = useAppSelector(getSettings);
  let [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") || PersonalAITabs.QUIZZES
  );

  return (
    <div dir={dir}>
      <HeaderSection
        bgImage={require("../../assets/images/persona-ai/personal-ai-header-bg.png")}
        onBack={'/'}
      >
        <div className="">
          <h1 className="text-white font-bold text-4xl">
            {t("personalaiTitle")}
          </h1>
          <p className="text-lg text-white mt-1 hidden md:contents">
            {t("personalaiSubtitle")}
          </p>
        </div>
        <div
          className={"flex items-center justify-start max-w-[min(100vw,768px)]"}
          lang={language}
          dir={dir}
        >
          {tabs.map((tab, idx) => (
            <button
              key={`--tab-${tab}-${idx}`}
              onClick={() => {
                setActiveTab(tab);
                setSearchParams({ tab: tab });
              }}
              className={`text-white w-1/2 md:w-1/3 pt-4 pb-2 border-b-[5px] transition-all duration-500 text-lg lg:text-xl font-heebo 
                ${
                  activeTab === tab
                    ? "bg-white bg-opacity-30 border-b-theme-blue"
                    : "bg-transparent border-b-white"
                }
                `}
            >
              {t(tab)}
            </button>
          ))}
        </div>
      </HeaderSection>
      <div className="container">{renderTab(activeTab)}</div>
    </div>
  );
}
